// Single-toggle feature flags for client-portal features that are
// implementation-complete but intentionally hidden behind a switch while
// they're being polished. Flip to `true` to re-enable; the underlying
// route + components stay wired up.
//
// VISUAL_EDITOR_ENABLED — when false, /portal/edits/visual renders a
// "Coming soon" placeholder, the entry-point button on the Edits page is
// hidden, and copy referencing the Visual Editor falls back to the Edits
// page. Set to true once the editor is stable.
//
// Deploy A shipped the rebuilt editor dormant behind this flag. Enabled
// 2026-06-20 (Deploy B): site-editor-bridge.js is live on all 20 Cloudflare
// Pages school sites and reports SPA navigation via History-API hooks, so the
// editor can track which page the user is on.
export const VISUAL_EDITOR_ENABLED = true;

// AUTO_RESOLVE_ENABLED — admin-only "Apply update" action on an edit request
// that runs the auto-resolve agent and shows the resulting diff in-portal for
// review. LOCAL PROTOTYPE ONLY for now: the endpoint calls a local agent-runner
// service (AUTO_RESOLVE_SERVICE_URL) which the Workers sandbox can't host. Keep
// false on production until the GitHub-App pipeline replaces the local runner.
export const AUTO_RESOLVE_ENABLED = true;

// AUTO_RESOLVE_BATCH_ENABLED — EXPERIMENTAL auto-resolve batch mode
// (docs/auto-resolve-batch.md): on Edit Requests filtered to one school, a
// Batch panel lists the school's open requests with a classification, sends
// the chosen ones to the school repo's auto-resolve-batch workflow as one run
// and one draft PR, and merges or discards it. Across schools: a chip per
// row, "Auto-resolve selected" in the bulk bar, a "Batch auto-resolve" header
// button and the "Batch runs" strip. Hides all of it when false.
// The server has its own switch: /api/admin/accounts/:id/auto-resolve-batch,
// /api/admin/auto-resolve-batches and /api/hooks/auto-resolve-batch answer
// 404 { code: 'disabled' } (and the list rows carry no classification) unless
// the Pages env var AUTO_RESOLVE_BATCH_ENABLED is 'true'. Keep false until the
// shadow tests in §9 hold.
// Always compiled in: the SERVER switch (AUTO_RESOLVE_BATCH_ENABLED in wrangler.toml [vars])
// decides. The panel renders nothing when the API answers 404 { code: 'disabled' }.
export const AUTO_RESOLVE_BATCH_ENABLED = true;
